import { trpc } from "@client/trpc";
import { useEffectiveUser } from "./use-effective-user";
import { useFeatureFlags } from "./use-feature-flag-enabled";

/** Use the viewer's audience when signed in and only EVERYONE when signed out. */
export function useResourcesEnabled(): boolean | undefined {
  const { data: viewer, isLoading } = useEffectiveUser();
  const flags = useFeatureFlags();
  const publicFlag = trpc.getLoggedOutResourcesEnabled.useQuery(undefined, {
    enabled: !isLoading && viewer == null,
    staleTime: 60_000,
    refetchInterval: 60_000,
    retry: false,
  });
  if (isLoading) return undefined;
  if (viewer) return flags.isError ? false : flags.data?.resources;
  return publicFlag.isError ? false : publicFlag.data;
}
